import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const SimulationParams = ({
  initialFund,
  setInitialFund,
  dailyCost,
  setDailyCost,
  targetRoi,
  setTargetRoi,
  simulationDays,
  setSimulationDays,
  title = 'Simulation Parameters',
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4">
          <div className="space-y-2">
            <Label htmlFor="initialFund">Initial Fund ($)</Label>
            <Input
              id="initialFund"
              type="number"
              value={initialFund}
              onChange={(e) => setInitialFund(Number(e.target.value))}
              placeholder="100000"
              min={0}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="dailyCost">Daily Cost ($)</Label>
            <Input
              id="dailyCost"
              type="number"
              value={dailyCost}
              onChange={(e) => setDailyCost(Number(e.target.value))}
              placeholder="1000"
              min={0}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="targetRoi">Target ROI (%)</Label>
            <Input
              id="targetRoi"
              type="number"
              value={targetRoi}
              onChange={(e) => setTargetRoi(Number(e.target.value))}
              placeholder="100"
              min={0}
              max={500}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="simulationDays">Simulation Days</Label>
            <Input
              id="simulationDays"
              type="number"
              value={simulationDays}
              onChange={(e) => setSimulationDays(Number(e.target.value))}
              placeholder="365"
              min={30}
              max={730}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default SimulationParams

